/* global Tena, Swiper */

(function($) {
    'use strict';

    Tena.ImageCarousel = {
        swiper: null,
        init: function() {
            // This is needed to make sure the swiper image carousel is correctly lazy loaded.
            // NOTE! This needs to be done before lazysizes is called.
            window.lazySizesConfig = window.lazySizesConfig || {};
            window.lazySizesConfig.loadHidden = false;

            Tena.ImageCarousel.bindEvents();
        },
        bindEvents: function() {
            $('ul.image-pager').css({ top: 0 });
            if ($('.image-carousel').length === 0 || Swiper === undefined) {
                return;
            }

            Tena.ImageCarousel.swiper = new Swiper('.swiper-container', {
                loop: true,
                preloadImages: false
            });

            // Sync active thumbnail on slide change.
            Tena.ImageCarousel.swiper.on('slideChange', function() {
                Tena.ImageCarousel.syncActiveThumbnail();
            });

            // Handle click on carousel arrows (left/right/up/down)

            $('.arrow', '.component-product-intro-right').on('click', function() {
                var $arrow = $(this);

                if (
                    $arrow.hasClass('arrow-left') ||
                    $arrow.hasClass('icon-nav-arrow-top')
                ) {
                    Tena.ImageCarousel.swiper.slidePrev();
                } else {
                    Tena.ImageCarousel.swiper.slideNext();
                }
            });
            var margin = parseInt($('ul.image-pager li').css('marginTop'), 10);
            var thumbHt = $('ul.image-pager li').outerHeight() + margin;
            var currentThumb = 0;
            $('.ThumbnailSlider > .icon').on('click', function() {
                var $arrow = $(this);
                var topPostition = parseInt($('ul.image-pager').css('top'), 10);
                if ($arrow.hasClass('icon-nav-arrow-top')) {
                    if (currentThumb === 0) {
                        return;
                    }
                    topPostition = topPostition + thumbHt;
                    currentThumb--;
                } else {
                    if (currentThumb === $('ul.image-pager li').length - 1) {
                        return;
                    }
                    topPostition = topPostition - thumbHt;
                    currentThumb++;
                }
                $('ul.image-pager').animate({ top: topPostition }, 'slow');
            });

            // Handle click on carousel thumbnail
            $('.image-pager li', '.ThumbnailSlider').on('click', function() {
                var $imagePagerItem = $(this);
                Tena.ImageCarousel.swiper.slideToLoop($imagePagerItem.index());
            });
        },
        syncActiveThumbnail: function() {
            var $imagePager = Tena.ImageCarousel.swiper.$el
                .closest('.component-product-intro-right')
                .find('.image-pager li');
            $imagePager
                .removeClass('active')
                .eq(Tena.ImageCarousel.swiper.realIndex)
                .addClass('active');
        }
    };
})(jQuery);
